(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("it5Nc", function(module, exports) {

var $80wRE = parcelRequire("80wRE");

var $7zKHz = parcelRequire("7zKHz");

var $57u2P = parcelRequire("57u2P");
let $d71f6db059661da8$var$map;
let $d71f6db059661da8$var$gMarkers = [];
let $d71f6db059661da8$var$markerClusterer = null;
let $d71f6db059661da8$var$lastIcon;
const $d71f6db059661da8$var$mapElement = document.getElementById("map");
const $d71f6db059661da8$var$mapSettings = JSON.parse($d71f6db059661da8$var$mapElement?.getAttribute("data-map") ?? "");
const $d71f6db059661da8$var$changeMarkersCheckboxes = document.querySelectorAll(".js-change-map-markers input");
let $d71f6db059661da8$var$markersType = "";
const $d71f6db059661da8$var$markers = JSON.parse($d71f6db059661da8$var$mapElement?.getAttribute("data-markers") ?? "").filter((item)=>item.lat != null && item.lng != null);
$d71f6db059661da8$var$changeMarkersCheckboxes.forEach((checkbox)=>{
    if (checkbox.checked) $d71f6db059661da8$var$markersType = checkbox.value;
    checkbox.addEventListener("change", ()=>{
        $d71f6db059661da8$var$markersType = checkbox.value;
        if ($d71f6db059661da8$var$map) $d71f6db059661da8$var$reloadMarkers($d71f6db059661da8$var$markersType, $d71f6db059661da8$var$map); // Check if map is initialized before calling this function
        (0, $7zKHz.filterBranchesCols)($d71f6db059661da8$var$markersType);
    });
});
const $d71f6db059661da8$var$setMarkers = async (markersType, map)=>{
    const { InfoWindow: InfoWindow } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement: AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const infoWindow = new InfoWindow({
        maxWidth: 328,
        minWidth: 296
    });
    // Clear any existing markers
    $d71f6db059661da8$var$gMarkers.forEach((marker)=>marker.map = null);
    $d71f6db059661da8$var$gMarkers = [];
    // Loop through the markers and create them
    $d71f6db059661da8$var$markers?.forEach((item)=>{
        if (markersType !== "" && item.type !== markersType) return;
        const marker = new AdvancedMarkerElement({
            map: map,
            position: {
                lat: Number(item.lat),
                lng: Number(item.lng)
            },
            content: $d71f6db059661da8$var$setIcon(item.icon.src)
        });
        $d71f6db059661da8$var$gMarkers.push(marker);
        marker.addListener("gmp-click", ()=>{
            $d71f6db059661da8$var$setDefaultIcon(item);
            $d71f6db059661da8$var$lastIcon = marker;
            marker.content = $d71f6db059661da8$var$setIcon(item.icon_active.src);
            infoWindow.close();
            infoWindow.setContent($d71f6db059661da8$var$popupElement(item.popup));
            const mapInstance = marker.map;
            if (mapInstance) {
                if (marker.position) infoWindow.setPosition(marker.position);
                infoWindow.open(mapInstance);
            } else console.error("Failed to get map instance.");
        });
    });
    // Initialize MarkerClusterer (only after markers are created)
    if ($d71f6db059661da8$var$markerClusterer) $d71f6db059661da8$var$markerClusterer.clearMarkers(); // Remove previous markers from the clusterer
    // Create a new MarkerClusterer with the updated markers
    $d71f6db059661da8$var$markerClusterer = new (0, $57u2P.MarkerClusterer)({
        markers: $d71f6db059661da8$var$gMarkers,
        map: map
    });
};
const $d71f6db059661da8$var$reloadMarkers = (markersType, map)=>{
    $d71f6db059661da8$var$gMarkers.forEach((marker)=>{
        marker.map = null;
    });
    $d71f6db059661da8$var$gMarkers = [];
    $d71f6db059661da8$var$setMarkers(markersType, map);
};
const $d71f6db059661da8$var$setIcon = (iconSrc)=>{
    const markerSvg = document.createElement("img");
    markerSvg.src = iconSrc;
    return markerSvg;
};
const $d71f6db059661da8$var$setDefaultIcon = (item)=>{
    if ($d71f6db059661da8$var$lastIcon) $d71f6db059661da8$var$lastIcon.content = $d71f6db059661da8$var$setIcon(item.icon.src);
};
const $d71f6db059661da8$var$disableDefaultUI = ()=>{
    if ($d71f6db059661da8$var$map) {
        const mobileQuery = window.matchMedia("(max-width: 36em)");
        if (!mobileQuery.matches) $d71f6db059661da8$var$map.setOptions({
            disableDefaultUI: false,
            streetViewControl: true,
            mapTypeControl: true
        });
        else $d71f6db059661da8$var$map.setOptions({
            disableDefaultUI: true,
            streetViewControl: false,
            mapTypeControl: false
        });
    }
};
const $d71f6db059661da8$var$popupElement = (popup)=>{
    const content = `
  <div class="i-map-branch u-border u-border-default p-2 u-rounded-2 u-posr overflow-hidden u-radius-sm d-grid gap-3 align-items-top h-100" data-type="b2b">
    ${popup.img ? `<a href="${popup.url}" class="i-map-branch__img-link u-img-hover d-block u-radius-xs">
      <div class="img u-posr overflow-hidden d-block  --placeholder --cover  --ratio-4-3 u-radius-xs">
        <picture>
        <img src="${popup.img.src ? popup.img.src : ""}" alt="" width="192" height="144" draggable="false" data-ll-status="loaded" class="entered loaded">
        </picture>
      </div>
      </a>` : ""}
    <div class="i-map-branch__content d-flex justify-content-between gap-1">
      <div class="i-map-branch__content-left d-flex flex-column gap-2">
        <div class="d-flex flex-column gap-1">
          <h3 class="base-heading mb-0 u-fw-700 u-text-balance u-h5">
            <a class="i-map-branch__heading-link u-clamp d-block u-color-text u-hover:color-text u-underline-transparent u-hover:underline-non-transparent" href="${popup.url}" title="${popup.title}">${popup.title}</a>
          </h3>
          <div>
            ${popup.description ? `<p class="u-fz-sm">${popup.description}</p>` : ""}
            ${popup.address ? `<p class="u-fz-sm">${popup.address.street ? popup.address.street + "," : ""} ${popup.address.zip ? popup.address.zip + "," : ""} ${popup.address.city}</p>` : ""}
          </div>
        </div>
        <div class="u-fz-sm">
          <span class="d-block mb-1 u-fw-600">Otev\xedrac\xed doba:</span>
          <table>
            <tbody>
            ${popup.opening_hours_short ? Object.entries(popup.opening_hours_short).map(([label, time])=>{
        const item = `
                <tr>
                  <th class="u-fw-400">${label}:</th>
                  <td class="px-1">${time}</td>
                </tr>`;
        return item;
    }).join("") : ""}
            </tbody>
          </table>
        </div>
      </div>
      <div class="i-map-branch__content-right d-flex flex-column justify-content-between flex-shrink-0 align-items-end">
        <div class="d-flex flex-column gap-1 align-items-end">
        ${popup.label ? `<span class="i-tag d-inline-flex gap-1 align-items-center justify-content-center text-center u-fw-600  --sm    text-uppercase">
            <span class="i-tag__title">${popup.label}</span>
          </span>` : ""}
        </div>
        <a class="btn u-posr u-cursor-pointer d-inline-flex gap-1 align-items-center justify-content-center flex-nowrap flex-shrink-0 --primary --sm   --icon-only" href="${popup.url}" title="Detail prodejny">
          <span class="btn__icon d-flex align-items-center justify-content-center">
            <span class="icon d-flex align-items-center justify-content-center --sm">
              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512">
                <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path>
              </svg>
            </span>
          </span>
        </a>
      </div>
    </div>
  </div>`;
    return content;
};
const $d71f6db059661da8$var$initMap = async ()=>{
    if (!$d71f6db059661da8$var$mapElement) return;
    const google1 = await (0, $80wRE.default)();
    $d71f6db059661da8$var$map = new google1.maps.Map($d71f6db059661da8$var$mapElement, {
        mapId: $d71f6db059661da8$var$mapSettings.map_id,
        center: $d71f6db059661da8$var$mapSettings.center,
        zoom: $d71f6db059661da8$var$mapSettings.zoom,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControlOptions: {
            position: google1.maps.ControlPosition.LEFT_BOTTOM
        }
    });
    $d71f6db059661da8$var$disableDefaultUI();
    window.addEventListener("resize", ()=>{
        $d71f6db059661da8$var$disableDefaultUI();
    });
    const latlngbounds = new google1.maps.LatLngBounds();
    if ($d71f6db059661da8$var$changeMarkersCheckboxes.length) (0, $7zKHz.filterBranchesCols)($d71f6db059661da8$var$markersType);
    else (0, $7zKHz.limitBranchesList)();
    $d71f6db059661da8$var$markers?.forEach((marker)=>{
        const latLng = new google1.maps.LatLng(marker.lat, marker.lng);
        latlngbounds.extend(latLng);
    });
    $d71f6db059661da8$var$setMarkers($d71f6db059661da8$var$markersType, $d71f6db059661da8$var$map);
    if ($d71f6db059661da8$var$markers.length > 1) {
        $d71f6db059661da8$var$map.setCenter(latlngbounds.getCenter());
        $d71f6db059661da8$var$map.fitBounds(latlngbounds);
    }
    $d71f6db059661da8$var$mapElement.classList.remove("--loading");
};
$d71f6db059661da8$var$initMap();

});
parcelRegister("80wRE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d47d0fe846d6826$export$2e2bcd8739ae039; });

var $f1Q1B = parcelRequire("f1Q1B");
const $5d47d0fe846d6826$var$options = {};
const $5d47d0fe846d6826$var$mapElements = document.querySelectorAll('.js-google-map');
let $5d47d0fe846d6826$var$apiKey = "";
$5d47d0fe846d6826$var$mapElements.forEach((element)=>{
    if (element.dataset.apiKey) $5d47d0fe846d6826$var$apiKey = element.dataset.apiKey;
});
const $5d47d0fe846d6826$var$loader = new (0, $f1Q1B.Loader)($5d47d0fe846d6826$var$apiKey, $5d47d0fe846d6826$var$options);
const $5d47d0fe846d6826$var$loadGoogleMaps = async ()=>{
    if (window.google && window.google.maps) {
        console.log("Google Maps API is already loaded.");
        return window.google;
    }
    console.log("Loading Google Maps API...");
    return await $5d47d0fe846d6826$var$loader.load();
};
var $5d47d0fe846d6826$export$2e2bcd8739ae039 = $5d47d0fe846d6826$var$loadGoogleMaps;

});
parcelRegister("f1Q1B", function(module, exports) {

$parcel$export(module.exports, "Loader", function () { return $af0f4e0e8dc84ba6$export$3b0d6d7590275603; });
class $af0f4e0e8dc84ba6$export$3b0d6d7590275603 {
    constructor(apiKey = null, options = {}){
        this.apiKey = apiKey;
        this.options = options;
        if (typeof window === 'undefined') throw new Error('google-maps is supported only in browser environment');
    }
    load() {
        if (typeof this.api !== 'undefined') return Promise.resolve(this.api);
        if (typeof this.loader !== 'undefined') return this.loader;
        window[$af0f4e0e8dc84ba6$export$3b0d6d7590275603.CALLBACK_NAME] = ()=>{
            this.api = window['google'];
            if (typeof this.resolve === 'undefined') throw new Error('Should not happen');
            this.resolve(this.api);
        };
        window['gm_authFailure'] = ()=>{
            if (typeof this.reject === 'undefined') throw new Error('Should not happen');
            this.reject(new Error('google-maps: authentication error'));
        };
        return this.loader = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
            const script = document.createElement('script');
            script.src = this.createUrl();
            script.async = true;
            script.onerror = (e)=>reject(e);
            document.head.appendChild(script);
        });
    }
    createUrl() {
        const parameters = [
            `callback=${$af0f4e0e8dc84ba6$export$3b0d6d7590275603.CALLBACK_NAME}`
        ];
        if (this.apiKey) parameters.push(`key=${this.apiKey}`);
        for(let name in this.options)if (this.options.hasOwnProperty(name)) {
            let value = this.options[name];
            if (name === 'version') name = 'v';
            if (name === 'libraries') value = value.join(',');
            parameters.push(`${name}=${value}`);
        }
        return `https://maps.googleapis.com/maps/api/js?${parameters.join('&')}`;
    }
}
$af0f4e0e8dc84ba6$export$3b0d6d7590275603.CALLBACK_NAME = '_dk_google_maps_loader_cb';

});


parcelRegister("7zKHz", function(module, exports) {

$parcel$export(module.exports, "filterBranchesCols", function () { return $58400746e739515b$export$bb5651b816e0f502; });
$parcel$export(module.exports, "limitBranchesList", function () { return $58400746e739515b$export$b48f5ddbf44ecc51; });
const $58400746e739515b$var$loadMoreBranchesButton = document.querySelector(".s-map__branch-button-load-more");
const $58400746e739515b$export$bb5651b816e0f502 = (branchType)=>{
    const branchesCols = document.querySelectorAll(".js-map-branch-item");
    branchesCols.forEach((col)=>{
        const branch = col.querySelector(".i-map-branch");
        col.classList.add("d-none");
        if (branch && branch.dataset.type == branchType) col.classList.remove("d-none");
    });
    $58400746e739515b$var$branchesColsListing();
    if ($58400746e739515b$var$loadMoreBranchesButton) $58400746e739515b$var$loadMoreBranchesButton.dataset.shownItems = String(10);
};
const $58400746e739515b$export$b48f5ddbf44ecc51 = ()=>{
    $58400746e739515b$var$branchesColsListing();
    if ($58400746e739515b$var$loadMoreBranchesButton) $58400746e739515b$var$loadMoreBranchesButton.dataset.shownItems = String(10);
};
const $58400746e739515b$var$branchesColsListing = (count)=>{
    const branchesCols = document.querySelectorAll(".js-map-branch-item:not(.d-none)");
    const limit = count ? count : 10;
    if (branchesCols.length > limit) $58400746e739515b$var$loadMoreBranchesButton?.classList.remove("d-none");
    else if (branchesCols.length <= limit) $58400746e739515b$var$loadMoreBranchesButton?.classList.add("d-none");
    branchesCols?.forEach((col, index)=>{
        if (index >= limit) col.classList.add("--hidden");
        else col.classList.remove("--hidden");
    });
};
$58400746e739515b$var$loadMoreBranchesButton?.addEventListener("click", (event)=>{
    event.preventDefault;
    let shownItems = Number($58400746e739515b$var$loadMoreBranchesButton.dataset.shownItems);
    shownItems += 10;
    $58400746e739515b$var$loadMoreBranchesButton.dataset.shownItems = String(shownItems);
    $58400746e739515b$var$branchesColsListing(shownItems);
});

});

parcelRegister("57u2P", function(module, exports) {

$parcel$export(module.exports, "MarkerClusterer", function () { return $3ba4e96e132ad9f5$export$58bd9bb9fcf3dd4f; });

var $5GlTO = parcelRequire("5GlTO");

var $a15BO = parcelRequire("a15BO");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $3ba4e96e132ad9f5$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */ class $3ba4e96e132ad9f5$export$87c23728007fa1bd {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $3ba4e96e132ad9f5$export$57ed47926628b770 {
    constructor({ markers: markers, position: position }){
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers)bounds.extend($3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker));
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */ get count() {
        return this.markers.filter((m)=>$3ba4e96e132ad9f5$export$87c23728007fa1bd.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */ push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */ delete() {
        if (this.marker) {
            $3ba4e96e132ad9f5$export$87c23728007fa1bd.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ const $3ba4e96e132ad9f5$export$6dcea57a2b662207 = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    const extendedMapBounds = $3ba4e96e132ad9f5$export$57247bea612a5e84(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains($3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker)));
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ const $3ba4e96e132ad9f5$export$57247bea612a5e84 = (bounds, projection, numPixels)=>{
    const { northEast: northEast, southWest: southWest } = $3ba4e96e132ad9f5$var$latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = $3ba4e96e132ad9f5$export$8cd793acb3b8e8e8({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return $3ba4e96e132ad9f5$export$21d7a872d22a0f92(extendedPixelBounds, projection);
};
/**
 * Gets the extended bounds as a bbox [westLng, southLat, eastLng, northLat]
 */ const $3ba4e96e132ad9f5$export$6341d7e267bda241 = (bounds, projection, pixels)=>{
    const extended = $3ba4e96e132ad9f5$export$57247bea612a5e84(bounds, projection, pixels);
    const ne = extended.getNorthEast();
    const sw = extended.getSouthWest();
    return [
        sw.lng(),
        sw.lat(),
        ne.lng(),
        ne.lat()
    ];
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ const $3ba4e96e132ad9f5$export$b59117efbc9c7af = (p1, p2)=>{
    const R = 6371; // Radius of the Earth in km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLon = (p2.lng - p1.lng) * Math.PI / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ const $3ba4e96e132ad9f5$var$latLngBoundsToPixelBounds = (bounds, projection)=>{
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ const $3ba4e96e132ad9f5$export$8cd793acb3b8e8e8 = ({ northEast: northEast, southWest: southWest }, numPixels)=>{
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ const $3ba4e96e132ad9f5$export$21d7a872d22a0f92 = ({ northEast: northEast, southWest: southWest }, projection)=>{
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class $3ba4e96e132ad9f5$export$1e1bee200f7e743e {
    constructor({ maxZoom: maxZoom = 16 }){
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ noop({ markers: markers }) {
        return $3ba4e96e132ad9f5$export$8793edee2d425525(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class $3ba4e96e132ad9f5$export$d8a438b9a55dba76 extends $3ba4e96e132ad9f5$export$1e1bee200f7e743e {
    constructor(_a){
        var { viewportPadding: viewportPadding = 60 } = _a, options = $3ba4e96e132ad9f5$var$__rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: $3ba4e96e132ad9f5$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
}
/**
 * @hidden
 */ const $3ba4e96e132ad9f5$export$8793edee2d425525 = (markers)=>{
    const clusters = markers.map((marker)=>new $3ba4e96e132ad9f5$export$57ed47926628b770({
            position: $3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class $3ba4e96e132ad9f5$export$dfa3b6d6f10e5cac extends $3ba4e96e132ad9f5$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxDistance: maxDistance = 40000, gridSize: gridSize = 40 } = _a, options = $3ba4e96e132ad9f5$var$__rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        const state = {
            zoom: map.getZoom()
        };
        let changed = false;
        if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
        else changed = !(0, (/*@__PURE__*/$parcel$interopDefault($5GlTO)))(this.state, state);
        this.state = state;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: changed
        };
        return {
            clusters: this.cluster({
                markers: $3ba4e96e132ad9f5$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    cluster({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for(let i = 0; i < this.clusters.length; i++){
            const candidate = this.clusters[i];
            const distance = $3ba4e96e132ad9f5$export$b59117efbc9c7af(candidate.bounds.getCenter().toJSON(), $3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster && $3ba4e96e132ad9f5$export$57247bea612a5e84(cluster.bounds, projection, this.gridSize).contains($3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker))) cluster.push(marker);
        else {
            const cluster = new $3ba4e96e132ad9f5$export$57ed47926628b770({
                markers: [
                    marker
                ]
            });
            this.clusters.push(cluster);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class $3ba4e96e132ad9f5$export$f6cacfea2ccd84d3 extends $3ba4e96e132ad9f5$export$1e1bee200f7e743e {
    constructor(_a){
        var options = $3ba4e96e132ad9f5$var$__rest(_a, []);
        super(options);
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        return {
            clusters: this.cluster({
                markers: markers,
                map: map,
                mapCanvasProjection: mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $3ba4e96e132ad9f5$export$3c4c9430ac0fb1eb extends $3ba4e96e132ad9f5$export$1e1bee200f7e743e {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60 } = _a, options = $3ba4e96e132ad9f5$var$__rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom: maxZoom
        });
        this.state = {
            zoom: -1
        };
        this.superCluster = new (0, $a15BO.default)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
    }
    calculate(input) {
        let changed = false;
        const state = {
            zoom: input.map.getZoom()
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5GlTO)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !(0, (/*@__PURE__*/$parcel$interopDefault($5GlTO)))(this.state, state);
        }
        this.state = state;
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map }) {
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(map.getZoom())).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $3ba4e96e132ad9f5$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $3ba4e96e132ad9f5$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $3ba4e96e132ad9f5$export$80a71135475bbaa7 extends $3ba4e96e132ad9f5$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60, viewportPadding: viewportPadding = 60 } = _a, options = $3ba4e96e132ad9f5$var$__rest(_a, [
            "maxZoom",
            "radius",
            "viewportPadding"
        ]);
        super({
            maxZoom: maxZoom,
            viewportPadding: viewportPadding
        });
        this.superCluster = new (0, $a15BO.default)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
        this.state = {
            zoom: -1,
            view: [
                0,
                0,
                0,
                0
            ]
        };
    }
    calculate(input) {
        const state = {
            zoom: Math.round(input.map.getZoom()),
            view: $3ba4e96e132ad9f5$export$6341d7e267bda241(input.map.getBounds(), input.mapCanvasProjection, this.viewportPadding)
        };
        let changed = !(0, (/*@__PURE__*/$parcel$interopDefault($5GlTO)))(this.state, state);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($5GlTO)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (changed) {
            this.clusters = this.cluster(input);
            this.state = state;
        }
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map, mapCanvasProjection: mapCanvasProjection }) {
        /* recalculate new state because we can't use the cached version. */ const state = {
            zoom: Math.round(map.getZoom()),
            view: $3ba4e96e132ad9f5$export$6341d7e267bda241(map.getBounds(), mapCanvasProjection, this.viewportPadding)
        };
        return this.superCluster.getClusters(state.view, state.zoom).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $3ba4e96e132ad9f5$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $3ba4e96e132ad9f5$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $3ba4e96e132ad9f5$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class $3ba4e96e132ad9f5$export$2deda6e6beba3286 {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        const clusterMarkerCounts = clusters.map((a)=>a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class $3ba4e96e132ad9f5$export$7db59afbbd5bcace {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ render({ count: count, position: position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if ($3ba4e96e132ad9f5$export$87c23728007fa1bd.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const parser = new DOMParser();
            const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map: map,
                position: position,
                zIndex: zIndex,
                title: title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position: position,
            zIndex: zIndex,
            title: title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3ba4e96e132ad9f5$var$extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(let property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ class $3ba4e96e132ad9f5$var$OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        $3ba4e96e132ad9f5$var$extend($3ba4e96e132ad9f5$var$OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $3ba4e96e132ad9f5$export$f87b0506a2cf0bc;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})($3ba4e96e132ad9f5$export$f87b0506a2cf0bc || ($3ba4e96e132ad9f5$export$f87b0506a2cf0bc = {}));
const $3ba4e96e132ad9f5$export$b434dc9855552644 = (_, cluster, map)=>{
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class $3ba4e96e132ad9f5$export$58bd9bb9fcf3dd4f extends $3ba4e96e132ad9f5$var$OverlayViewSafe {
    constructor({ map: map, markers: markers = [], algorithmOptions: algorithmOptions = {}, algorithm: algorithm = new $3ba4e96e132ad9f5$export$3c4c9430ac0fb1eb(algorithmOptions), renderer: renderer = new $3ba4e96e132ad9f5$export$7db59afbbd5bcace(), onClusterClick: onClusterClick = $3ba4e96e132ad9f5$export$b434dc9855552644 }){
        super();
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        $3ba4e96e132ad9f5$export$87c23728007fa1bd.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
     * Recalculates and draws all the marker clusters.
     */ render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, $3ba4e96e132ad9f5$export$f87b0506a2cf0bc.CLUSTERING_BEGIN, this);
            const { clusters: clusters, changed: changed } = this.algorithm.calculate({
                markers: this.markers,
                map: map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters){
                    if (cluster.marker == null) continue;
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        $3ba4e96e132ad9f5$export$87c23728007fa1bd.setMap(cluster.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(cluster.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>$3ba4e96e132ad9f5$export$87c23728007fa1bd.setMap(marker, null)));
            }
            google.maps.event.trigger(this, $3ba4e96e132ad9f5$export$f87b0506a2cf0bc.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>$3ba4e96e132ad9f5$export$87c23728007fa1bd.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new $3ba4e96e132ad9f5$export$2deda6e6beba3286(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>$3ba4e96e132ad9f5$export$87c23728007fa1bd.setMap(marker, null));
                if (this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ (event)=>{
                    google.maps.event.trigger(this, $3ba4e96e132ad9f5$export$f87b0506a2cf0bc.CLUSTER_CLICK, cluster);
                    this.onClusterClick(event, cluster, map);
                });
            }
            $3ba4e96e132ad9f5$export$87c23728007fa1bd.setMap(cluster.marker, map);
        });
    }
}

});
parcelRegister("5GlTO", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("a15BO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74ae592c96ec3c1a$export$2e2bcd8739ae039; });

var $8EsPt = parcelRequire("8EsPt");
const $74ae592c96ec3c1a$var$defaultOptions = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
const $74ae592c96ec3c1a$var$fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
const $74ae592c96ec3c1a$var$OFFSET_ZOOM = 2;
const $74ae592c96ec3c1a$var$OFFSET_ID = 3;
const $74ae592c96ec3c1a$var$OFFSET_PARENT = 4;
const $74ae592c96ec3c1a$var$OFFSET_NUM = 5;
const $74ae592c96ec3c1a$var$OFFSET_PROP = 6;
class $74ae592c96ec3c1a$export$2e2bcd8739ae039 {
    constructor(options){
        this.options = Object.assign(Object.create($74ae592c96ec3c1a$var$defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    load(points) {
        const { log: log, minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (log) console.time('total time');
        const timerId = `prepare ${points.length} points`;
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];
        for(let i = 0; i < points.length; i++){
            const p = points[i];
            if (!p.geometry) continue;
            const [lng, lat] = p.geometry.coordinates;
            const x = $74ae592c96ec3c1a$var$fround($74ae592c96ec3c1a$var$lngX(lng));
            const y = $74ae592c96ec3c1a$var$fround($74ae592c96ec3c1a$var$latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(let z = maxZoom; z >= minZoom; z--){
            const now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log('z%d: %d clusters in %dms', z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd('total time');
        return this;
    }
    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            const westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range($74ae592c96ec3c1a$var$lngX(minLng), $74ae592c96ec3c1a$var$latY(maxLat), $74ae592c96ec3c1a$var$lngX(maxLng), $74ae592c96ec3c1a$var$latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids){
            const k = this.stride * id;
            clusters.push(data[k + $74ae592c96ec3c1a$var$OFFSET_NUM] > 1 ? $74ae592c96ec3c1a$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $74ae592c96ec3c1a$var$OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = 'No cluster with the specified id.';
        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids){
            const k = id * this.stride;
            if (data[k + $74ae592c96ec3c1a$var$OFFSET_PARENT] === clusterId) children.push(data[k + $74ae592c96ec3c1a$var$OFFSET_NUM] > 1 ? $74ae592c96ec3c1a$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $74ae592c96ec3c1a$var$OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const { extent: extent, radius: radius } = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;
        const tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);
        for (const child of children){
            const props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        const tree = new (0, $8EsPt.default)(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids){
            const k = i * this.stride;
            const isCluster = data[k + $74ae592c96ec3c1a$var$OFFSET_NUM] > 1;
            let tags, px, py;
            if (isCluster) {
                tags = $74ae592c96ec3c1a$var$getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + $74ae592c96ec3c1a$var$OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = $74ae592c96ec3c1a$var$lngX(lng);
                py = $74ae592c96ec3c1a$var$latY(lat);
            }
            const f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags: tags
            };
            // assign id
            let id;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + $74ae592c96ec3c1a$var$OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + $74ae592c96ec3c1a$var$OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        const { radius: radius, extent: extent, reduce: reduce, minPoints: minPoints } = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;
        // loop through each point
        for(let i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + $74ae592c96ec3c1a$var$OFFSET_ZOOM] <= zoom) continue;
            data[i + $74ae592c96ec3c1a$var$OFFSET_ZOOM] = zoom;
            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);
            const numPointsOrigin = data[i + $74ae592c96ec3c1a$var$OFFSET_NUM];
            let numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (const neighborId of neighborIds){
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + $74ae592c96ec3c1a$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $74ae592c96ec3c1a$var$OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;
                let clusterProperties;
                let clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $74ae592c96ec3c1a$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $74ae592c96ec3c1a$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    const numPoints2 = data[k + $74ae592c96ec3c1a$var$OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;
                    data[k + $74ae592c96ec3c1a$var$OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }
                data[i + $74ae592c96ec3c1a$var$OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                for(let j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $74ae592c96ec3c1a$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $74ae592c96ec3c1a$var$OFFSET_ZOOM] = zoom;
                    for(let j = 0; j < stride; j++)nextData.push(data[k + j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + $74ae592c96ec3c1a$var$OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + $74ae592c96ec3c1a$var$OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + $74ae592c96ec3c1a$var$OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}
function $74ae592c96ec3c1a$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: 'Feature',
        id: data[i + $74ae592c96ec3c1a$var$OFFSET_ID],
        properties: $74ae592c96ec3c1a$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: 'Point',
            coordinates: [
                $74ae592c96ec3c1a$var$xLng(data[i]),
                $74ae592c96ec3c1a$var$yLat(data[i + 1])
            ]
        }
    };
}
function $74ae592c96ec3c1a$var$getClusterProperties(data, i, clusterProps) {
    const count = data[i + $74ae592c96ec3c1a$var$OFFSET_NUM];
    const abbrev = count >= 10000 ? `${Math.round(count / 1000)}k` : count >= 1000 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + $74ae592c96ec3c1a$var$OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $74ae592c96ec3c1a$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $74ae592c96ec3c1a$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $74ae592c96ec3c1a$var$latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $74ae592c96ec3c1a$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $74ae592c96ec3c1a$var$yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

});
parcelRegister("8EsPt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64c86c0d8ae4c638$export$2e2bcd8739ae039; });
const $64c86c0d8ae4c638$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ const $64c86c0d8ae4c638$var$VERSION = 1; // serialized format version
const $64c86c0d8ae4c638$var$HEADER_SIZE = 8;
class $64c86c0d8ae4c638$export$2e2bcd8739ae039 {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error('Data must be an instance of ArrayBuffer.');
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error('Data does not appear to be in a KDBush format.');
        const version = versionAndType >> 4;
        if (version !== $64c86c0d8ae4c638$var$VERSION) throw new Error(`Got v${version} data when expected v${$64c86c0d8ae4c638$var$VERSION}.`);
        const ArrayType = $64c86c0d8ae4c638$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error('Unrecognized array type.');
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);
        return new $64c86c0d8ae4c638$export$2e2bcd8739ae039(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */ constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data){
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = $64c86c0d8ae4c638$var$ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $64c86c0d8ae4c638$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $64c86c0d8ae4c638$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer($64c86c0d8ae4c638$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $64c86c0d8ae4c638$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $64c86c0d8ae4c638$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($64c86c0d8ae4c638$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
     * Perform indexing of the added points.
     */ finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        // kd-sort both arrays for efficient search
        $64c86c0d8ae4c638$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ within(qx, qy, r) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        const r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++)if ($64c86c0d8ae4c638$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if ($64c86c0d8ae4c638$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $64c86c0d8ae4c638$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $64c86c0d8ae4c638$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $64c86c0d8ae4c638$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $64c86c0d8ae4c638$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $64c86c0d8ae4c638$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $64c86c0d8ae4c638$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        const t = coords[2 * k + axis];
        let i = left;
        let j = right;
        $64c86c0d8ae4c638$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $64c86c0d8ae4c638$var$swapItem(ids, coords, left, right);
        while(i < j){
            $64c86c0d8ae4c638$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $64c86c0d8ae4c638$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $64c86c0d8ae4c638$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $64c86c0d8ae4c638$var$swapItem(ids, coords, i, j) {
    $64c86c0d8ae4c638$var$swap(ids, i, j);
    $64c86c0d8ae4c638$var$swap(coords, 2 * i, 2 * j);
    $64c86c0d8ae4c638$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $64c86c0d8ae4c638$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $64c86c0d8ae4c638$var$sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}

});




})();
//# sourceMappingURL=map-section.eacb7079.js.map
